import React from 'react'

const Disclaimer = () => {
  return (
    <div className="mx-auto md:max-w-screen-sm sm:p-8 p-3">
      <h4 className="mt-16 text-3xl ">Sobre este interactivo</h4>
      <p>
        Los nombres que se incluyen aquí son los que están publicados en la{' '}
        <strong>
          última nómina de candidatos y candidatas a Convencionales
          Constituyentes
        </strong>{' '}
        <a href="https://elecciones2021.servel.cl/convencionales-constituyentes/">
          publicada por el Servel el 11 de marzo
        </a>
        . Tras haber publicado nuestra primera versión de este interactivo, el{' '}
        {''} <strong>20 de enero</strong>, comenzamos a chequear a cada uno de
        los candidatos y a <strong>contactarlos por diversas vías</strong>{' '}
        (teléfono, correo electrónico, redes sociales), para solicitarles
        información que aparecería en su <strong>ficha de perfil</strong> o se
        utilizaría con fines estadísticos. También se les invitó a responder la
        encuesta de nuestro{' '}
        <a
          href="https://interactivo.latercera.com/tu-match-constituyente/candidatos-constituyentes/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-rojolt">
          Match Constituyente
        </a>
        . A nivel nacional, alrededor de{' '}
        <strong>un 65% de los candidatos han respondido</strong> y seguimos
        recibiendo información diariamente, que iremos actualizando.
      </p>
      <p>
        La información de cada votante fue obtenida del padrón electoral
        auditado, que el Servel dispone públicamente en{' '}
        <a
          href="https://www.servel.cl/padron-electoral-auditado-elecciones-abril-2021/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-rojolt">
          su sitio web
        </a>
        .
      </p>

      <p>
        <strong>¿Eres candidato?</strong> ¿Quieres agregar{' '}
        <strong>más información a tu ficha</strong> y hacer nuestro Match
        Constituyente?{' '}
        <a
          href="https://docs.google.com/forms/d/1kRJJl6-V8Hg8kfhaRssKkQ1A35JL5ytJnpLeLJuuD3A/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-rojolt">
          Contáctanos
        </a>
        .
      </p>
    </div>
  )
}

export default Disclaimer
